import React, { useEffect } from "react";

const UPDATED_AT = "14 de Setembro de 2025";

export default function PoliticaPrivacidade() {
  useEffect(() => {
    document.title = "Política de Privacidade | Luciana Costa";
  }, []);

  return (
    <main className="container py-4" style={{ maxWidth: 900 }}>
      <h1 className="h3 fw-bold mb-3">Política de Privacidade</h1>
      <p className="text-muted mb-4">
        Última atualização: <time dateTime="2025-09-14">{UPDATED_AT}</time>
      </p>

      <article className="lh-base" style={{ whiteSpace: "normal" }}>
        <p className="bg-light border rounded p-3">
          Esta Política explica como o site{" "}
          <a href="https://lucianacosta.cv">lucianacosta.cv</a> recolhe, usa e
          protege os dados pessoais dos seus utilizadores e clientes, em
          conformidade com o Regulamento Geral de Proteção de Dados (RGPD) e a
          legislação de Cabo Verde.
        </p>

        <h2 className="h6 fw-semibold mt-4">1) Responsável pelo tratamento</h2>
        <p>
          <strong>Mãos de Luz Terapias Holísticas, Lda.</strong>, com sede em
          Achada Santo António, Praia, Cabo Verde, é responsável pelo
          tratamento dos dados pessoais recolhidos neste site.  
          Contacto:{" "}
          <a href="mailto:info@lucianacosta.cv">info@lucianacosta.cv</a>.
        </p>

        <h2 className="h6 fw-semibold mt-4">2) Dados recolhidos</h2>
        <ul>
          <li>Dados de identificação (nome, email, telefone);</li>
          <li>Dados de autenticação (login e palavra-passe);</li>
          <li>
            Dados de transação e faturação (morada, NIF, meio de pagamento);
          </li>
          <li>Dados técnicos (endereço IP, cookies, tipo de dispositivo).</li>
        </ul>

        <h2 className="h6 fw-semibold mt-4">3) Finalidades do tratamento</h2>
        <ul>
          <li>Criação e gestão da conta de utilizador;</li>
          <li>Processamento de encomendas e pagamentos;</li>
          <li>Envio de confirmações, faturas e links de download;</li>
          <li>Resposta a pedidos de apoio e contacto;</li>
          <li>Melhoria da experiência do utilizador e estatísticas internas.</li>
        </ul>

        <h2 className="h6 fw-semibold mt-4">4) Base legal</h2>
        <p>
          O tratamento é realizado com base em:
        </p>
        <ul>
          <li>Execução de contrato (compra e entrega de produtos/serviços);</li>
          <li>Consentimento do titular (newsletter ou comunicações opcionais);</li>
          <li>Interesse legítimo (segurança, prevenção de fraude, estatísticas).</li>
        </ul>

        <h2 className="h6 fw-semibold mt-4">5) Partilha de dados</h2>
        <p>
          Os dados podem ser partilhados apenas com entidades parceiras
          estritamente necessárias à operação:
        </p>
        <ul>
          <li>
            <strong>SISP</strong> — processamento de pagamentos Vinti4 (dados do
            cartão não são guardados pelo site);
          </li>
          <li>
            <strong>Stripe</strong> e <strong>PayPal</strong> — quando
            selecionados pelo utilizador;
          </li>
          <li>
            <strong>Serviços de email e alojamento</strong> (ex.: Brevo, Render,
            MongoDB Atlas) — para envio de comunicações e gestão de dados.
          </li>
        </ul>

        <h2 className="h6 fw-semibold mt-4">6) Conservação dos dados</h2>
        <p>
          Os dados são conservados apenas pelo tempo necessário às finalidades
          referidas ou conforme obrigações legais (ex.: contabilidade).
          Utilizadores podem solicitar a eliminação dos seus dados a qualquer
          momento.
        </p>

        <h2 className="h6 fw-semibold mt-4">7) Direitos do titular</h2>
        <p>O utilizador tem direito a:</p>
        <ul>
          <li>Aceder, retificar ou eliminar os seus dados pessoais;</li>
          <li>Limitar ou opor-se ao tratamento;</li>
          <li>Solicitar portabilidade dos dados;</li>
          <li>Retirar o consentimento, quando aplicável.</li>
        </ul>
        <p>
          Para exercer os seus direitos, contacte-nos por email:
          <a href="mailto:info@lucianacosta.cv"> info@lucianacosta.cv</a>.
        </p>

        <h2 className="h6 fw-semibold mt-4">8) Cookies</h2>
        <p>
          O site utiliza cookies essenciais (funcionais) e analíticos (Google
          Analytics) para melhorar a navegação e medir visitas. O utilizador
          pode gerir as preferências no seu navegador.
        </p>

        <h2 className="h6 fw-semibold mt-4">9) Segurança</h2>
        <p>
          Adotamos medidas técnicas e organizativas adequadas para proteger os
          dados contra perda, uso indevido, acesso não autorizado ou destruição,
          incluindo encriptação e ligações HTTPS.
        </p>

        <h2 className="h6 fw-semibold mt-4">10) Alterações a esta política</h2>
        <p>
          Esta Política pode ser atualizada a qualquer momento. A versão
          publicada em{" "}
          <a href="https://lucianacosta.cv">lucianacosta.cv</a> substitui as
          anteriores.
        </p>

        <hr className="my-4" />
        <p className="small text-muted">
          Em caso de dúvidas ou para exercer os teus direitos, contacta-nos em{" "}
          <a href="mailto:info@lucianacosta.cv">info@lucianacosta.cv</a>.
        </p>
      </article>
    </main>
  );
}
